<template>
    <div class="panel">
        <div class="panel-head">
            <div>
                <div class="panel-title">Guest Origin</div>
            </div>
        </div>

        <div v-if="!origins.length" class="empty-state">No sales data yet</div>

        <div class="origin-item" v-for="o in origins" :key="o.name">
            <span class="origin-code">{{ o.code }}</span>
            <div class="origin-info">
                <div class="origin-name">{{ o.name }}</div>
                <div class="origin-track">
                    <div class="origin-fill" :style="{ width: o.pct + '%' }"></div>
                </div>
            </div>
            <div class="origin-pct">{{ o.pct }}%</div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        origins: { type: Array, default: () => [] }
    }
}
</script>

<style lang="scss" scoped>
.panel {
    background: var(--surface);
    border: 1px solid var(--line);
    border-radius: var(--radius);
    box-shadow: var(--shadow);
    padding: 1.25rem 1.4rem;
    height: 100%;
}

.panel-title {
    font-size: .95rem;
    font-weight: 700;
}

.panel-sub {
    font-size: .72rem;
    color: var(--ink-faint);
    margin-top: .15rem;
}

.panel-head {
    margin-bottom: .5rem;
}

.empty-state {
    font-size: .78rem;
    color: var(--ink-faint);
    padding: .75rem 0;
}

.origin-item {
    display: flex;
    align-items: center;
    gap: .6rem;
    margin-top: .75rem;
}

.origin-code {
    font-family: 'IBM Plex Mono', monospace;
    font-size: .62rem;
    font-weight: 700;
    letter-spacing: .03em;
    color: var(--ocean);
    background: var(--ocean-soft);
    border-radius: 5px;
    padding: .2rem .35rem;
    min-width: 26px;
    text-align: center;
    flex-shrink: 0;
}

.origin-info {
    flex: 1;
    min-width: 0;
}

.origin-name {
    font-size: .8rem;
    font-weight: 600;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.origin-track {
    background: var(--line);
    border-radius: 3px;
    height: 5px;
    margin-top: .3rem;
    overflow: hidden;
}

.origin-fill {
    height: 100%;
    background: var(--amber);
    border-radius: 3px;
}

.origin-pct {
    font-family: 'IBM Plex Mono', monospace;
    font-size: .75rem;
    font-weight: 600;
    color: var(--ink-soft);
    flex-shrink: 0;
}
</style>


// WEBPACK FOOTER //
// guestOrigin.vue?0bc8bd4a